import { SVG, SVGProps } from './svg'

export function IconCandleBarHollow(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path fillRule="evenodd" d="M13 0h-2v6H8v12h3v6h2v-6h3V6h-3V0Zm1 8h-4v8h4V8Z" />
    </SVG>
  )
}
